import axios from 'axios'
import api from '@/api/api'
import state from '@/store/module_principal/state'

export default {
  buscaradares (cidade) {
    var info = { cidade: cidade }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/retornaRadares', token, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  pesquisaplacaspg (usuario, pesquisa, cidade, page, pagesize) {
    var info = {
      l1: pesquisa.L1,
      l2: pesquisa.L2,
      l3: pesquisa.L3,
      n1: pesquisa.N1,
      n2: pesquisa.N2,
      n3: pesquisa.N3,
      n4: pesquisa.N4,
      dataInicio: pesquisa.strDateInicial,
      dataFim: pesquisa.strDateFinal,
      horaInicio: pesquisa.strHoraInicial,
      horaFim: pesquisa.strHoraFinal,
      radares: pesquisa.strSelectdPontos,
      tipoPesquisa: pesquisa.selectedTipo,
      cidade: cidade,
      codigo: usuario.codUsuario,
      username: usuario.txtLogin.toLowerCase(),
      page: page,
      pageSize: pagesize
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) };
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/pesquisaPlacasPg', token, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        },
        timeout: 1000 * 180, //aumentando o timeout para 180 segundos = 3 minutos
    }).then(result => result.data)
  },
  pesquisaqtdplacas (usuario, pesquisa, cidade) {
    var info = {
      l1: pesquisa.L1,
      l2: pesquisa.L2,
      l3: pesquisa.L3,
      n1: pesquisa.N1,
      n2: pesquisa.N2,
      n3: pesquisa.N3,
      n4: pesquisa.N4,
      dataInicio: pesquisa.strDateInicial,
      dataFim: pesquisa.strDateFinal,
      horaInicio: pesquisa.strHoraInicial,
      horaFim: pesquisa.strHoraFinal,
      radares: pesquisa.strSelectdPontos,
      tipoPesquisa: pesquisa.selectedTipo,
      cidade: cidade,
      codigo: usuario.codUsuario,
      username: usuario.txtLogin.toLowerCase()
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/pesquisaQtdPlacas', token, {
      headers: {
        "content-type": "application/x-www-form-urlencoded"
      },
      timeout: 1000 * 180, //aumentando o timeout para 180 segundos = 3 minutos
    }).then(result => result.data)
  },
  //buscacorporacoes: function(e) {
  //    var t = {
  //        cidade: e
  //    };
  //    return $e.a.post(ia.ip.protocolo + "://" + ia.ip.backendIp + ia.ip.backendPort + "/retornaCorporacoes", JSON.stringify(t), {
  //        withCredentials: !0,
  //        headers: {
  //            "content-type": "application/x-www-form-urlencoded"
  //        }
  //    }).then((function(e) {
  //        return e.data
  //    }))
  //},
  buscaimagem (imagem, cidade) {
    var info = {
      img: imagem,
      cidade: cidade
    }
    var token = {
      token: api.aesEncrypt(JSON.stringify(info))
    };
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/imagem', token, {
      headers: {
        "content-type": "application/x-www-form-urlencoded"
      }
    }).then(result => result.data)
  },
  salvarimagem (usuario, clientinfo, cidade, nomeImagem) {
      var info = {
              codigo: usuario.codUsuario,
              username: usuario.nomUsuario.toLowerCase(),
              ip: clientinfo.ip,
              city: clientinfo.city,
              region: clientinfo.region,
              regioncode: clientinfo.region_code,
              country: clientinfo.country,
              countrycode: clientinfo.country_code,
              countryname: clientinfo.country_name,
              latitude: clientinfo.latitude,
              longitude: clientinfo.longitude,
              browsername: clientinfo.browser_name,
              browserversion: clientinfo.browser_version,
              osname: clientinfo.os_name,
              ismobile: clientinfo.is_mobile,
              mobilemodel: clientinfo.mobile_model,
              mobilefactory: clientinfo.mobile_factory,
              cidade: cidade,
              imagemsalvar: nomeImagem
          }
      var token = { token: api.aesEncrypt(JSON.stringify(info)) }
      return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/salvarImagem', token, {
          headers: {
              "content-type": "application/x-www-form-urlencoded"
          }
      }).then(result => result.data)
  },
}